<template>
<section class="breakout-feature px-4 py-15% bg-primary-900 relative">

    <BackgroundImage v-if="background_image" :src="background_image.src" :alt="background_image.alt" opacity="0.4"></BackgroundImage>
    <Burn v-if="background_image" direction="right" start="0%" end="50%"></Burn>

    <div class="max-w-4xl mx-auto relative z-20">
        <div class="grid">
            <SmoothLoader class="left vt:pt-8">
                <h2 v-html="headline" class="headline text-gray-500 text-4xl vt:text-7xl font-headline font-bold mt-8 mb-4 vt:my-0 leading-tight"></h2>
            </SmoothLoader>
            <SmoothLoader class="right" :delay="200">
                <div class="prose text-gray-500" v-html="blurb">
                </div>
                <div v-if="button" class="mt-8">
                    <Button :url="button.url" :label="button.label"></Button>
                </div>
            </SmoothLoader>
        </div>
    </div>
</section>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
export default {
    props: ['data'],
    setup(props) {
        return {
            ...props.data
        }
    }
}
</script>